const getIsEdge = () => {
  if (typeof window === 'undefined') return false;
  const agent = window.navigator.userAgent.toLowerCase();
  return agent.indexOf('edg/') > -1;
};

const getIsTWA = () => {
  if (typeof window === 'undefined') return false;
  const isTWA = document.referrer.startsWith('android-app://xyz.limhenry.slides.lite');
  if (isTWA) sessionStorage.setItem('rfs:isTWA', true);
  const session = sessionStorage.getItem('rfs:isTWA');
  return isTWA || session === 'true';
};

const getTwaVersion = () => {
  if (typeof window === 'undefined') return false;
  const session = sessionStorage.getItem('rfs:TWAVersion');
  const params = new URLSearchParams(window.location.search);
  const ver = params.get('twa_version')?.toLowerCase() || session;
  const regex = /^\d{4}\.(0[1-9]|1[012])\.(0[1-9]|[12][0-9]|3[01])/;
  if (!regex.test(ver)) return false;
  sessionStorage.setItem('rfs:TWAVersion', ver);
  return `${ver}.TWA`;
};

export default {
  isEdge: getIsEdge(),
  isTWA: getIsTWA(),
  twaVersion: getTwaVersion(),
  isSnackbarShow: false,
};
